import React, { Component } from 'react';
import { Modal } from 'antd';

class ConfirmModal extends Component {
  render() {
    return (
      <Modal
        title={this.props.title || ''}
        onOk={() => this.props.onConfirm()}
        okText={this.props.okText || ''}
        okType={this.props.okType || ''}
        onCancel={() => this.props.onCancel()}
        cancelText={this.props.cancelText || ''}
        visible={this.props.isVisible}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export default ConfirmModal;
